module.exports = __webpack_public_path__ + "img/brief_1.5f1f05cc.png";